import gql from 'graphql-tag';

export const FINANCE_INSURANCE_PERFORMANCE_REPORT = gql`
  query FinanceInsurancePerformanceReport($input: FinanceInsurancePerformanceReportInput!) {
    financeInsurancePerformanceReport(input: $input) {
      rows {
        name
        deals
        fiDeals
        financePenetration
        escPenetration
        insurancePenetration
        gapPenetration
        roadsidePenetration
        financeProfit
        escProfit
        insuranceProfit
        gapProfit
        roadsideProfit
        totalProfit
        avgProfitPerDeal
        avgProfitPerFiDeals
      }
    }
  }
`;
